import type { TFunction } from 'i18next';
import type { DispensasjonType, DispensasjonFra } from '@origo/planregister';
import { DISPENSASJONSTYPE_VALUES, DISPENSASJONFRA_VALUES } from '@origo/planregister';
import type { SelectOption } from '../types';

const TYPE_CODES: readonly DispensasjonType[] = DISPENSASJONSTYPE_VALUES;
const FRA_CODES: readonly DispensasjonFra[] = DISPENSASJONFRA_VALUES;

export function dispensasjonTypeLabel(code: DispensasjonType | string | undefined, t: TFunction): string {
    if (!code) return '';
    return t(`codelists.dispensasjonType.${code}`, { defaultValue: code });
}

export function dispensasjonTypeOptions(t: TFunction): SelectOption[] {
    return TYPE_CODES.map(code => ({ value: code, label: dispensasjonTypeLabel(code, t) }));
}

export function dispensasjonFraLabel(code: DispensasjonFra | string | undefined, t: TFunction): string {
    if (!code) return '';
    return t(`codelists.dispensasjonFra.${code}`, { defaultValue: code });
}

export function dispensasjonFraOptions(t: TFunction): SelectOption[] {
    return FRA_CODES.map(code => ({ value: code, label: dispensasjonFraLabel(code, t) }));
}
